import EsSummaryView, {type EsSummaryViewProps} from '@/pages/components/audit-program/e-section/EsSummaryView';
import {HS_PAGE, type HSummaryPage} from '@/pages/components/audit-program/h-section/constants';

export type HsSummaryViewProps = Omit<EsSummaryViewProps, 'page' | 'fallback' | 'refCode'> & {
    page: HSummaryPage;
    refCode?: string;
};

/** Hs — Summary sheet for other investments objectives (same layout as Es). */
export default function HsSummaryView({
    page,
    refCode = 'Hs',
    ...rest
}: HsSummaryViewProps) {
    return <EsSummaryView {...rest} page={page} fallback={HS_PAGE} refCode={refCode}/>;
}
